import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ChromePicker } from "react-color";
import "../styles/CadastroCliente.css";

const SetupCliente = () => {
  const { id } = useParams();
  const [clienteNome, setClienteNome] = useState("");
  const [parametros, setParametros] = useState({
    logo_url: "",
    cor_cabecalho: "#0f172a",
    cor_sidebar: "#1e293b",
    cor_fundo_conteudo: "#f8fafc",
    cor_texto_primario: "#000000",
    cor_texto_secundario: "#64748b",
    cor_fundo_principal: "#ffffff",
  });

  const [selectedColorKey, setSelectedColorKey] = useState(null);

  useEffect(() => {
    axios.get(`http://localhost:5000/api/clientes/${id}`).then((res) => {
      setClienteNome(res.data.razao_social);
    });
  }, [id]);

  useEffect(() => {
    axios
      .get(`http://localhost:5000/api/parametros_cliente/${id}`)
      .then((res) => setParametros(res.data))
      .catch(() => {
        setParametros({
          logo_url: "",
          cor_cabecalho: "#0f172a",
          cor_sidebar: "#1e293b",
          cor_fundo_conteudo: "#f8fafc",
          cor_texto_primario: "#000000",
          cor_texto_secundario: "#64748b",
          cor_fundo_principal: "#ffffff"
        });
      });
  }, [id]);

  const handleChange = (key, value) => {
    setParametros((prev) => ({ ...prev, [key]: value }));
  };

  const handleSalvar = () => {
    axios
      .post("http://localhost:5000/api/parametros_cliente", {
        cliente_id: id,
        ...parametros,
      })
      .then(() => {
        alert("Parâmetros salvos com sucesso.");
        window.location.reload(); // força atualização visual
      })
      .catch((err) => {
        console.error(err);
        alert("Erro ao salvar parâmetros.");
      });
  };
  

  const handleColorClick = (key) => {
    setSelectedColorKey(key);
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Setup Visual</h2>
      <p style={{ fontSize: "0,9rem", color: "#1E448B", marginTop: "-12px", marginBottom: "20px" }}>{clienteNome}</p>

      <div className="form-group form-group-full">
        <label>Logo do Cliente (Upload)</label>
        <input
          type="file"
          accept="image/*"
          onChange={async (e) => {
            const file = e.target.files[0];
            if (file) {
              const formData = new FormData();
              formData.append("file", file);
              try {
                const response = await axios.post("http://localhost:5000/api/upload_logo", formData, {
                  headers: { "Content-Type": "multipart/form-data" }
                });
                handleChange("logo_url", response.data.url); // Supondo que o backend retorne { url: ... }
              } catch (err) {
                console.error("Erro no upload:", err);
                alert("Falha ao enviar logo.");
              }
            }
          }}
        />
        {parametros.logo_url && (
          <img
            src={parametros.logo_url}
            alt="Logo preview"
            style={{ width: "120px", marginTop: "10px", border: "1px solid #ccc", borderRadius: "6px" }}
          />
        )}
      </div>

      <h3 style={{ marginTop: "30px", marginBottom: "10px" }}>Personalize Cores</h3>
      <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: "300px" }}>
          {[ 
            { key: "cor_cabecalho", label: "Cor do Cabeçalho" },
            { key: "cor_sidebar", label: "Cor da Sidebar" },
            { key: "cor_fundo_conteudo", label: "Cor de Fundo" },
            { key: "cor_texto_primario", label: "Cor do Texto Primário" },
            { key: "cor_texto_secundario", label: "Cor do Texto Secundário" },
            { key: "cor_fundo_principal", label: "Cor da Área Principal" },
          ].map(({ key, label }) => (
            <div
              key={key}
              style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer", marginBottom: "12px" }}
              onClick={() => handleColorClick(key)}
            >
              <div
                style={{
                  backgroundColor: parametros[key],
                  width: "30px",
                  height: "30px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                title={label}
              />
              <span>{label}</span>
            </div>
          ))}
        </div>

        <div
          style={{
            flex: 1,
            minWidth: "280px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            paddingTop: "0px",
            minHeight: "320px",
          }}
        >
          {selectedColorKey && (
            <ChromePicker
              color={parametros[selectedColorKey]}
              onChange={(color) => handleChange(selectedColorKey, color.hex)}
              disableAlpha
              styles={{
                default: {
                  picker: {
                    width: "280px",
                  },
                },
              }}
            />
          )}
        </div>
      </div>

      <button
        onClick={handleSalvar}
        style={{
          marginTop: "10px",
          padding: "7px 15px",
          backgroundColor: "#3b82f6",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          transition: "all 0.2s ease-in-out",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#2563eb")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#3b82f6")}
        onMouseDown={(e) => (e.target.style.transform = "scale(0.97)")}
        onMouseUp={(e) => (e.target.style.transform = "scale(1)")}
      >
        Salvar
      </button>

    </div>
  );
};

export default SetupCliente;